import { forwardRef, Ref, type SVGProps } from 'react';

const SvgMinusIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 12"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={2}
      d="M2 6h8"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMinusIcon);
export default ForwardRef;
